package org.matthewo.schema

const val CRI_YEAR_PREFIX = 100_000

val Int.isCRI get() = this in CRI_YEAR_PREFIX..<2 * CRI_YEAR_PREFIX

val Int.base get() = this % CRI_YEAR_PREFIX

val CRI_YEAR_MAP = mapOf(
    2021 to "2021-2022-off-cri",
    2022 to "2022-2023-off-cri",
    2023 to "2023-2024-off-cri",
    2024 to "2024-2025-cri",
).mapKeys { CRI_YEAR_PREFIX + it.key }

fun <T> Sequence<T>.sortedByYearDescending(selector: (T) -> Int) =
    sortedBy { selector(it) }.sortedByDescending { selector(it) % CRI_YEAR_PREFIX }

fun <T> Iterable<T>.sortedByYearDescending(selector: (T) -> Int) =
    sortedBy { selector(it) }.sortedByDescending { selector(it) % CRI_YEAR_PREFIX }
